import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  BOOKING_RESTRICTION_ACTIVE_BOOKING_EVENT,
  BOOKING_RESTRICTION_EXPIRED_EVENT,
} from "../../utils/bookingRestriction";

const EXPIRED_MESSAGE = "You are not able to make a booking. Please contact your club.";
const ACTIVE_BOOKING_MESSAGE =
  "You already have an active booking. You can make a new booking once it is completed or cancelled.";

// Popup for an expired PrivateClubWorld Member Subscription, opened by handleBookingRestriction.
const BookingRestrictionModal = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(EXPIRED_MESSAGE);

  useEffect(() => {
    const handleExpired = () => {
      setMessage(EXPIRED_MESSAGE);
      setOpen(true);
    };
    const handleActiveBooking = () => {
      setMessage(ACTIVE_BOOKING_MESSAGE);
      setOpen(true);
    };
    window.addEventListener(BOOKING_RESTRICTION_EXPIRED_EVENT, handleExpired);
    window.addEventListener(BOOKING_RESTRICTION_ACTIVE_BOOKING_EVENT, handleActiveBooking);
    return () => {
      window.removeEventListener(BOOKING_RESTRICTION_EXPIRED_EVENT, handleExpired);
      window.removeEventListener(BOOKING_RESTRICTION_ACTIVE_BOOKING_EVENT, handleActiveBooking);
    };
  }, []);

  return (
    <Modal
      show={open}
      onHide={() => setOpen(false)}
      backdrop="static"
      keyboard={false}
      className="confirm-logout-modal"
    >
      <Modal.Header closeButton>
        <h4>Booking Unavailable</h4>
      </Modal.Header>
      <Modal.Body className="text-center space-y-2">
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => setOpen(false)}
          style={{
            border: "1px solid var(--sandy-brown)",
            color: "var(--sandy-brown)",
            backgroundColor: "var(--black)",
          }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BookingRestrictionModal;
